import { computed, runInAction } from 'mobx'
import { RoomStatus } from 'messaging/rooms/Room'
import { task } from 'mobx-task'
import { browserHistory } from 'react-router'
import link from '../../../misc/links'
import QS from 'qs'

export default class RoomViewModel {
  constructor({ projectDetailsStore, roomStore }) {
    this.projectDetailsStore = projectDetailsStore
    this.roomStore = roomStore
  }

  @computed
  get room() {
    return (
      this.roomStore.rooms.get(
        this.projectDetailsStore.project.consultation?.room?.id
      ) ?? undefined
    )
  }

  @computed
  get activeRoom() {
    return this.room?.status === RoomStatus.Active ?? false
  }

  @computed
  get isRoomClosed() {
    return this.room?.status === RoomStatus.Closed ?? false
  }

  join = task.resolved(async () => {
    if (!this.projectDetailsStore.project || !this.room) {
      return
    }

    const qs = QS.parse(location.search, { ignoreQueryPrefix: true })
    runInAction(() => {
      browserHistory.push(
        link.projectRoom(
          this.projectDetailsStore.project.id,
          this.room.id,
          qs?.hideNavbar
        )
      )
    })
  })
}
